/**
 * Utility functions for string manipulation and formatting.
 */

/**
 * Robustly strips HTML tags and their inner content (like styles and scripts) 
 * from a given string, returning only the plain text.
 * 
 * @param html The HTML string to strip
 * @returns Plain text representation
 */
export const stripHtml = (html: string | undefined | null): string => {
    if (!html) return '';

    // First, remove <style> and <script> tags and all their inner content
    let text = html.replace(/<(style|script)[^>]*>[\s\S]*?<\/\1>/gi, '');

    // Then remove all remaining HTML tags
    text = text.replace(/<[^>]*>?/gm, '');

    // Convert common HTML entities
    text = text.replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'");

    // Collapse multiple whitespaces and trim
    return text.replace(/\s+/g, ' ').trim();
};

/**
 * Kaba HTML tespiti: metinde en az bir etiket var mı?
 *
 * Bildirim içerikleri çoğu kodda tam HTML e-posta gövdesidir (9 KB+). Böyle bir metnin
 * düz yazı olarak basıldığı yerlerde (toast, önizleme) ekran ham kaynak kodla dolar.
 */
export const isHtml = (value: string | undefined | null): boolean =>
    !!value && /<[a-z!/][^>]*>/i.test(value);

/** Uzun metni tek parça hâlinde kısaltır (önizleme/toast için). */
export const truncate = (value: string | undefined | null, maxLength: number): string => {
    const text = (value ?? '').trim();
    if (text.length <= maxLength) return text;
    return `${text.slice(0, Math.max(0, maxLength - 1)).trimEnd()}…`;
};
